import styled from "styled-components";
import {LastLoginDefaultBox} from "./last-login.default.box";

export const LastLoginSiBox = styled(LastLoginDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        border-left: 1px solid ${props => props.theme.colors.boxBorderContrast};
    }
`